(function () {
  function loadPendingMedia(slide) {
    if (!slide || slide.dataset.mediaLoaded === 'true') {
      return;
    }

    slide.querySelectorAll('.hero__slide-media--pending').forEach(function (pending) {
      var bgset = pending.getAttribute('data-bgset-pending');
      if (!bgset) {
        return;
      }

      pending.classList.remove('hero__slide-media--pending');
      pending.classList.add('lazyload');
      pending.setAttribute('data-bgset', bgset);
      pending.removeAttribute('data-bgset-pending');

      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.unveil(pending);
      }
    });

    slide.dataset.mediaLoaded = 'true';
  }

  function initWrapper(wrapper) {
    var slides = wrapper.querySelectorAll('.slideshow__slide');
    if (!slides.length) {
      return;
    }

    var loadSlide = function (index) {
      var slide = slides[index];
      if (slide) {
        loadPendingMedia(slide);
      }
    };

    var bindFlickity = function (flkty) {
      if (!flkty || flkty._homeDeferBound) {
        return;
      }
      flkty._homeDeferBound = true;
      loadSlide(flkty.selectedIndex || 0);
      var nextIndex = (flkty.selectedIndex || 0) + 1;
      if (slides[nextIndex]) {
        loadSlide(nextIndex);
      }
      flkty.on('change', function (index) {
        loadSlide(index);
        if (slides[index + 1]) {
          loadSlide(index + 1);
        }
      });
    };

    var tryBind = function (detail) {
      var flkty =
        (detail && detail.flkty) ||
        (window.Flickity && window.Flickity.data(wrapper)) ||
        (wrapper.flickity && wrapper.flickity);
      if (flkty) {
        bindFlickity(flkty);
        return true;
      }
      return false;
    };

    var onReady = function (event) {
      if (event.target !== wrapper && !wrapper.contains(event.target)) {
        return;
      }
      tryBind(event.detail);
    };

    document.addEventListener('theme:slideshow:ready', onReady);
    wrapper.addEventListener('ready.flickity', onReady);

    if (tryBind()) {
      return;
    }

    var attempts = 0;
    var timer = setInterval(function () {
      if (tryBind() || ++attempts > 80) {
        clearInterval(timer);
      }
      if (attempts > 80) {
        loadSlide(0);
      }
    }, 100);
  }

  function boot() {
    if (!document.body.classList.contains('template-index')) {
      return;
    }
    document.querySelectorAll('[data-slideshow-wrapper]').forEach(initWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-slideshow-wrapper]').forEach(initWrapper);
  });
})();
